export let enrollValidation = {
    onfocusout: function (element) {
        this.element(element);
    },
    highlight: function (element) {
        const $modField = $(element).closest('.mod-field');
        if($modField.length) {
            $modField.addClass('mod-field--error');
        } else {
            $(element).parent().addClass('is--error');
        }
    },
    unhighlight: function (element) {
        const $modField = $(element).closest('.mod-field');
        if($modField.length) {
            $modField.removeClass('mod-field--error');
        } else {
            $(element).parent().removeClass('is--error');
        }
    },
    errorElement: 'span',
    rules: {
        firstName: {
            required: true,
            checkForInvalidChars: true
        },
        lastName: {
            required: true,
            checkForInvalidChars: true
        },
        secondLastName: {
            required: false,
            checkForInvalidChars: true
        },
        email: {
            email: true,
            required: true,
            patternMatches: true
        },
        address1Input: {
            required: true,
            addressFieldHasInvalidChars: true
        },
        address2Input: {
            required: isRequiredAddressLine(2),
            addressFieldHasInvalidChars: true
        },
        address3Input: {
            required: false,
            addressFieldHasInvalidChars: true
        },
        address4Input: {
            required: '#address4Input' && isRequiredAddressLine(4),
            addressFieldHasInvalidChars: true
        },
        cityInput: {
            required: true,
            addressFieldHasInvalidChars: true
        },
        phoneCountryCode: {
            required: true,
            valueNotEquals: 'default'
        },
        stateInput: {
            required: true,
            valueNotEquals: 'default'
        },
        language: {
            required: true,
            valueNotEquals: 'default'
        },
        zipCodeInput: {
            required: true,
            patternMatches: true
        },
        username: {
            required: true,
            checkForInvalidChars: true
        },
        password: {
            required: '#password',
            maxlength: 20,
            minlength: 8,
      customRegex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@\$%\^&\+\-=,\._]).*$/, //eslint-disable-line
            notEqualToCustom: '#username',
            notContain: ' '
        },
        confirmPassword: {
            equalToCustom: '#password',
            required: '#confirmPassword'
        },
        phone: {
            required: true,
            isValidFormat: true,
            isValidPhoneNumber: true
        },
        communications: {
            required: true
        }
    }
};

function isRequiredAddressLine(addressLine) {
    let requiredAddressLines = $('#requiredAddressLines').val() || [];
    if(requiredAddressLines.indexOf(addressLine) >= 0) {
        return true;
    }
    return false;
}
